import { useDeliveryLoaders, useDeliveryOrderLoaders } from "../../../modules/deliveries"
import { useSaleOperationLoaders } from "../../../modules/sales"
import { Address } from "../types"

export const useAddressHooks = () => {
    const saleOperationLoaders = useSaleOperationLoaders()
    const deliveryOrderLoaders = useDeliveryOrderLoaders()
    const deliveryLoaders = useDeliveryLoaders()
    
    const canRemoveAddress = async (addressId: string): Promise<boolean> => {
        const { countDeliveryOrders } = deliveryOrderLoaders()
        const deliveryOrdersCount = await countDeliveryOrders('addressId', addressId)
        
        const { countDeliveries } = deliveryLoaders()
        const deliveriesCount = await countDeliveries('addressId', addressId)

        const { loadSaleOperationsWithProp } = saleOperationLoaders()
        const operationsWithDeliveryData = await loadSaleOperationsWithProp('deliveryData', true)
        const operations = operationsWithDeliveryData.filter(operation => operation.deliveryData?.addressId === addressId)

        return deliveryOrdersCount === 0 && deliveriesCount === 0 && operations.length === 0
    }

    return {
        canRemoveAddress
    }
}

export const addressHelpers = {
    describeAddress: (addressData: Partial<Address>, showBetweenStreets = true): string => {
        const { address, betweenStreets, locality, province } = addressData
        const betweenStreetsLabel = showBetweenStreets && betweenStreets ? ` (entre ${betweenStreets})` : ''
        const localityLabel = locality ? ', ' + locality : ''
        const provinceLabel = province ? ', ' + province : ''
        return `${address!}${betweenStreetsLabel}${localityLabel}${provinceLabel}`
    },
    
    parseAddress: (addressDescription: string): Partial<Address> => {
        const provinceIndex = addressDescription.lastIndexOf(', ')
        const province = addressDescription.substring(provinceIndex + 2)
        let rest = addressDescription.substring(0, provinceIndex)
        const localityIndex = rest.lastIndexOf(', ')
        const locality = rest.substring(localityIndex + 2)
        rest = rest.substring(0, localityIndex)
        const betweenStreetsIndex = rest.indexOf(' (entre ')
        const betweenStreets = betweenStreetsIndex !== -1 ? rest.substring(betweenStreetsIndex + 8, rest.length - 1) : undefined
        const address = betweenStreetsIndex !== -1 ? rest.substring(0, betweenStreetsIndex) : rest
        return { address, betweenStreets, locality, province }
    },

    matchesAddress: (addressDescription: string, address: Partial<Address>): boolean => {
        const parsedAddress = addressHelpers.parseAddress(addressDescription)
        return address.address === parsedAddress.address &&
            address.betweenStreets === parsedAddress.betweenStreets &&
            address.locality === parsedAddress.locality &&
            address.province === parsedAddress.province
    }
}
